import { Answers } from '@care-portals/api-interfaces';

const META_ANSWER_KEYS = new Set(['states']);

export function hasAnswerData(value: unknown): boolean {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === 'boolean' || typeof value === 'number') {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value as object).length > 0;
  }

  return !!value;
}

export function validateSubmittedConsultationAnswers(
  type: string,
  answers: Answers,
): void {
  if (!answers || typeof answers !== 'object') {
    throw new Error('Consultation answers cannot be empty');
  }

  const substantiveKeys = Object.keys(answers).filter(
    key => !META_ANSWER_KEYS.has(key)
  );

  const hasSubstantiveData = substantiveKeys.some(key =>
    hasAnswerData(answers[key])
  );

  if (!hasSubstantiveData) {
    throw new Error('Consultation answers cannot be empty');
  }

  
}
